/* =============================================================================
   assets/rm-country-selector.js
   Country/currency selector dropdown — open/close, search filter,
   and form submission on selection.
   ============================================================================= */

(function () {
  'use strict';

  /* ── Init a single selector instance ── */
  function initSelector(container) {
    const btnEl       = container.querySelector('[id^="country-selector-btn-"]');
    const panelEl     = container.querySelector('[id^="country-selector-panel-"]');
    const searchEl    = container.querySelector('[id^="country-search-"]');
    const listEl      = container.querySelector('[id^="country-list-"]');
    const noResultsEl = container.querySelector('.country-selector__no-results');

    if (!btnEl || !panelEl) return;

    /* Open */
    function open() {
      panelEl.hidden = false;
      btnEl.setAttribute('aria-expanded', 'true');
      if (searchEl) {
        searchEl.value = '';
        filterOptions('');
        searchEl.focus();
      }
      // Scroll selected option into view
      listEl?.querySelector('.is-selected')?.scrollIntoView({ block: 'nearest' });
    }

    /* Close */
    function close() {
      panelEl.hidden = true;
      btnEl.setAttribute('aria-expanded', 'false');
    }

    /* Toggle */
    btnEl.addEventListener('click', e => {
      e.stopPropagation();
      panelEl.hidden ? open() : close();
    });

    /* Close on outside click */
    document.addEventListener('click', e => {
      if (!container.contains(e.target)) close();
    });

    /* Close on Escape */
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !panelEl.hidden) {
        close();
        btnEl.focus();
      }
    });

    /* Search filter */
    function filterOptions(query) {
      const q       = query.toLowerCase().trim();
      const options = listEl?.querySelectorAll('.country-selector__option') || [];
      const groups  = listEl?.querySelectorAll('.country-selector__group-label') || [];
      let   visible = 0;

      options.forEach(opt => {
        const name    = opt.getAttribute('data-name') || '';
        const matches = !q || name.indexOf(q) !== -1;
        opt.style.display = matches ? '' : 'none';
        if (matches) visible++;
      });

      // Hide group headers during search
      groups.forEach(g => { g.style.display = q ? 'none' : ''; });

      if (noResultsEl) noResultsEl.hidden = visible > 0;
    }

    searchEl?.addEventListener('input', () => filterOptions(searchEl.value));

    /* Select a country option */
    listEl?.addEventListener('click', e => {
      const option = e.target.closest('.country-selector__option');
      if (!option) return;

      const countryCode = option.getAttribute('data-country');
      const formId      = option.getAttribute('data-form');
      const formEl      = formId ? document.getElementById(formId) : null;

      if (formEl && countryCode) {
        const codeInput = formEl.querySelector('[name="country_code"]');
        if (codeInput) codeInput.value = countryCode;
        close();
        formEl.submit();
      }
    });
  }

  /* ── Init all selectors on the page ── */
  function initAll() {
    document.querySelectorAll('.country-selector').forEach(initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
